import type { CardSkeletonProps } from "./card-skeleton.type";

import { Avatar, Card, Skeleton } from "antd";

export const CardSkeleton = ({ withTitle, withAvatar }: CardSkeletonProps) => {
  const simpleCard = !withTitle && !withAvatar;

  return (
    <Card loading={simpleCard} className="card-skeleton">
      {!simpleCard && (
        <Skeleton loading avatar={withAvatar} active>
          <Card.Meta
            title="title"
            description="description"
            avatar={withAvatar ? <Avatar src="avatar" /> : undefined}
          />
        </Skeleton>
      )}
    </Card>
  );
};
